export enum Role {
	Teacher = 'Teacher',
	Principal = 'Principal',
	Area = 'Area',
	AdminLite = 'Admin-Lite',
	Admin = 'Admin',
}
